import { TextField } from '@hypeit-gmbh/hypeit-ui';
import { Grid, TextInputProps } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useContactPrefix } from '../Root';

type FaxPropsType = {
  span?: number;
} & TextInputProps;

export const Fax: React.FC<FaxPropsType> = ({ span, ...props }) => {
  const { t } = useTranslation();
  const prefix = useContactPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <TextField
        fieldName={`${prefix}.fax`}
        label={t(`${TRANS_KEY}.FAX_LABEL`)}
        {...props}
      />
    </Grid.Col>
  );
};
